export const isStorybook = typeof process !== 'undefined' && process.env.STORYBOOK === 'true';
